import * as Yup from 'yup';
import { emptyStringToNull } from 'screens/Equipment/EquipmentItem/schema';

// eslint-disable-next-line import/prefer-default-export
export const EQUIPMENT_SCHEMA = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('Name is required'),
  type: Yup.string().required('Type is required'),
  currentStatus: Yup.string().required('Current Status is required'),
  year: Yup.number()
    .nullable()
    .transform(emptyStringToNull)
    .integer('Year must be a whole number')
    .min(1000, 'Year must be a 4-digit year')
    .max(9999, 'Year must be a 4-digit year')
});
